import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import ArrowButton from '../../../../../../components/arrow-button';
import { ROUTES } from '../../../../../../routes/routes';
import { ChannelBoxIcon } from '../../../../components/channel/box-icon';
import { getPreciseChannelType } from '../../../../utils';

type DeviceChannelsProps = {
  channels: IDeviceChannel[];
};

export const DeviceChannels: React.FC<DeviceChannelsProps> = ({ channels }) => {
  const navigate = useNavigate();

  return (
    <section className="device-settings__channels grid-list-24 m-t-32">
      {channels.map((channel) => {
        if (channel) {
          return (
            <ArrowButton
              key={channel.Number}
              title={channel.Name}
              icon={
                <ChannelBoxIcon
                  channel={channel}
                  className="device-box__head-icon device-box__head-icon--no-width m-b-0"
                />
              }
              onClick={() =>
                navigate(
                  `${ROUTES.ChannelConfiguration(
                    getPreciseChannelType(channel),
                    `${channel.GetDevice().Guid}_${channel.Number}`,
                  )}?redirect=true`,
                )
              }
              className={classNames('m-b-24 big-radius', { hidden: channel.IsHidden })}
            />
          );
        }
      })}
    </section>
  );
};
